module.exports = __webpack_public_path__ + "static/mca-page-models.0cebd254.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/mca/mca-page-models.jpg
// module id = 474
// module chunks = 181542127041897